import { CheapTournamentEntryFee, getFilterGroups } from "./tournament-filters";

export function getTournamentsForList(tournaments, list, tags) {
  var tag = currentTag(list, tags);
  var f = filters[list] || filterForTag(list, tag);
  return tournaments.valueSeq().filter(f).sort(comparators[list] || tournamentComparator);
}

export function getFilteredTournamentsForList(tournaments, list, filter, tokenTypes, races, tags) {
  var tag = currentTag(list, tags);
  var filterGroups = getFilterGroups(tournaments, races, tag);
  var filterGroupNames = filterGroups.map(g => g.key);
  var f = filterGroupNames.reduce((combinedFilter, name) => {
    var filterKeys = asArray(filter[name]) || ["all"];
    var userFilter = getUserFilter(filterGroups, name, filterKeys);
    return (tournament) => combinedFilter(tournament) && userFilter(tournament, tokenTypes, races);
  }, yes);
  return tournaments.valueSeq().filter(f).sort(comparators[list] || tournamentComparator);
}

function currentTag(list, tags) {
  return tags.valueSeq().find(t => t.get("name") === list);
}

const filters = {
  upcoming: isUpcoming,
  head2head: isHead2Head,
  highstakes: isHighStakes,
  eightandunder: isCheap,
  points: isPoints,
  qualify: isNhcOrQualifier,
  harness: isHarness,
  survivor: isSurvivor,
  started: isStarted
};

function isUpcoming(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && (
      tournament.get("upcoming")
      || tournament.get("featured")
      || (tournament.get("max_users") > 2 && tournament.get("money_buy_in_amount") > CheapTournamentEntryFee && tournament.get("tournament_type") !== "Survivor" && tournament.get("has_harness_race") !== true)
    );
}
function isHead2Head(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && tournament.get("max_users") === 2
    && tournament.get("tournament_type") !== "Survivor"
    && tournament.get("has_harness_race") !== true
    && tournament.get("remaining_entries") > 0;
}
function isHighStakes(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && tournament.get("money_buy_in_amount") >= 225
    && tournament.get("tournament_type") !== "Survivor"
    && tournament.get("has_harness_race") !== true;
}
function isCheap(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && (tournament.get("money_buy_in_amount") <= CheapTournamentEntryFee || !exists(tournament.get("money_buy_in_amount")))
    && tournament.get("tournament_type") !== "Survivor"
    && tournament.get("has_harness_race") !== true
    && tournament.get("remaining_entries") > 0;
}
function isPoints(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && (tournament.get("points_buy_in_amount") > 0);
}
function isNhcOrQualifier(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && tournament.get("qualifier") === true;
}
function isHarness(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && tournament.get("has_harness_race") === true;
}
function isSurvivor(tournament) {
  return (tournament.get("status") === "scheduled" || tournament.get("status") === "open")
    && tournament.get("tournament_type") === "Survivor";
}
function isStarted(tournament) {
  return tournament.get("status") === "running"
    || tournament.get("status") === "final";
}

function exists(val) {
  return val !== undefined && val !== null;
}

var filtersForTag = {};
function filterForTag(list, tag) {
  if (!tag) {
    return nothing;
  }
  var tagId = tag.get("id");
  if (typeof filtersForTag[list] !== "function") {
    filtersForTag[list] = function(tournament) {
      return tournament.get("tags").includes(tagId);
    };
  }
  return filtersForTag[list];
}

function nothing() {
  return false;
}

function getUserFilter(filterGroups, groupKey, filterKeys) {
  var g = filterGroups.filter(group => group.key === groupKey)[0];
  if (!g) {
    return yes;
  }

  if (g.filter) {
    return (tournament, tokenTypes, races) => g.filter(filterKeys, tournament, tokenTypes, races);
  }

  var groupFilters = g.filters.reduce((byKeys, filter) => {
    byKeys[filter.key] = filter;
    return byKeys;
  }, {});

  return composeOr(filterKeys.map(key => groupFilters[key].fn || yes));
}

function composeOr(fns) {
  return (tournament, tokenTypes) => {
    for (var i = 0; i < fns.length; i++) {
      if (fns[i](tournament, tokenTypes)) {
        return true;
      }
    }
    return false;
  };
}

function yes() {
  return true;
}

function asArray(strOrArray) {
  if (typeof strOrArray === "string") {
    return [strOrArray];
  } else {
    return strOrArray;
  }
}

const comparators = {
  head2head: head2headComparator,
  started: startedComparator
};

function startedComparator(a, b) {
  if (a.get("featured") !== b.get("featured")) {
    return a.get("featured") ? -1 : 1; // true before false
  }
  return new Date(b.get("starts_at")) - new Date(a.get("starts_at"));
}

function tournamentComparator(a, b) {
  if (a.get("featured") !== b.get("featured")) {
    return a.get("featured") ? -1 : 1; // true before false
  }
  if (a.get("display_game_on_top") !== b.get("display_game_on_top")) {
    return a.get("display_game_on_top") ? -1 : 1; // true before false
  }
  var startDiff = new Date(a.get("starts_at")) - new Date(b.get("starts_at"));
  if (startDiff !== 0) {
    return startDiff;
  }
  var aFull = a.get("remaining_entries") === 0;
  var bFull = b.get("remaining_entries") === 0;
  if (aFull !== bFull) {
    return aFull ? 1 : -1; // false before true
  }
  return a.get("id") - b.get("id");
}

function head2headComparator(a, b) {
  if (a.get("featured") !== b.get("featured")) {
    return a.get("featured") ? -1 : 1; // true before false
  }
  if (a.get("display_game_on_top") !== b.get("display_game_on_top")) {
    return a.get("display_game_on_top") ? -1 : 1; // true before false
  }
  var ticketCountDiff = b.get("tickets").count() - a.get("tickets").count();
  if (ticketCountDiff !== 0) {
    return ticketCountDiff;
  }
  var startDiff = new Date(a.get("starts_at")) - new Date(b.get("starts_at"));
  if (startDiff !== 0) {
    return startDiff;
  }
  var aFull = a.get("remaining_entries") === 0;
  var bFull = b.get("remaining_entries") === 0;
  if (aFull !== bFull) {
    return aFull ? 1 : -1; // false before true
  }
  return a.get("id") - b.get("id");
}
